import { Injectable } from "@angular/core";
import { environment } from "@env/environment";
import { BehaviorSubject } from "rxjs";
import { MaintenanceConfig } from "./maintenance-config.model";

@Injectable({
    providedIn: 'root'
})
export class MaintenanceService {
  maintenanceActivated: BehaviorSubject<boolean> = new BehaviorSubject(false);
  showBanner: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor () {}

  nextMaintenanceActivatedSubject(value: boolean) {
    this.maintenanceActivated.next(value);
  }

  getMaintenanceActivatedSubject(): boolean {
    return this.maintenanceActivated.value;
  }

  nextShowBannerSubject(value: boolean) {
    this.showBanner.next(value);
  }

  getShowBannerSubject(): boolean {
    return this.showBanner.value;
  }

  getMaintenanceConfig(): MaintenanceConfig | null {
    const localConfig = environment.maintenance;

    if (localConfig) {
      const config: MaintenanceConfig = {
        enabled: localConfig.enabled || false,
        from: localConfig.from ? new Date(localConfig.from) : undefined,
        to: localConfig.to ? new Date(localConfig.to) : undefined,
        message: localConfig.message,
        banner: {
          enabled: localConfig.banner?.enabled || false,
          message: localConfig.banner?.message,
          displayBefore: localConfig.banner?.displayBefore || "P14D" // Set default value here
        }
      };
      return config;
    }

    return null;
  }
}
